var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "sector-post" },
    [
      _c(
        "div",
        { staticClass: "sector-post__content" },
        [
          _c(
            "div",
            { staticClass: "sector-post__creator" },
            [
              _vm.resource.creator
                ? _c("UserCard", {
                    attrs: {
                      user: _vm.resource.creator,
                      borderless: true,
                      small: true,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sector-post__details" },
            [
              _c("span", { staticClass: "sector-post__date" }, [
                _vm.resource.is_edited
                  ? _c("span", { staticClass: "edited" }, [_vm._v("EDITED - ")])
                  : _vm._e(),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resource.date) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.resource.sector_options
                ? _c("SectorPopup", {
                    attrs: { sectors: _vm.resource.sector_options },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.resource.can && _vm.resource.can.edit && _vm.showActions
            ? _c(
                "button",
                {
                  attrs: { id: "context-menu-button", type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.handleContextMenuClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("SvgIcon", {
                    staticClass: "interaction-btn__icon",
                    attrs: { icon: "filled-context-menu", "is-filled": true },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Open Context Menu")]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.media[0]
            ? _c("picture", { staticClass: "sector-post__image" }, [
                _c("img", {
                  attrs: { src: _vm.resource.media[0].url, alt: "" },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.post_content
            ? [
                _vm.showReadMore
                  ? _c("ReadMore", {
                      attrs: {
                        content: _vm.resource.post_content,
                        "wrapper-class": { "sector-post__copy": true },
                      },
                    })
                  : _c("div", {
                      staticClass: "sector-post__copy",
                      domProps: {
                        innerHTML: _vm._s(_vm.resource.post_content),
                      },
                    }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.opportunities && _vm.resource.opportunities.length > 0
            ? _vm._l(_vm.resource.opportunities, function (opportunity) {
                return _c("SectorPostCardOpportunity", {
                  key: _vm.resource.id,
                  attrs: { resource: opportunity },
                })
              })
            : _vm.resource.madds && _vm.resource.madds.length > 0
            ? _vm._l(_vm.resource.madds, function (madd) {
                return _c("SectorPostCardMadd", {
                  key: _vm.resource.id,
                  attrs: { resource: madd },
                })
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.files && _vm.resource.files.length > 0
            ? [
                _c("SectorPostCardFiles", {
                  attrs: { files: _vm.resource.files },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.links && _vm.resource.links.length > 0
            ? _vm._l(_vm.resource.links, function (link) {
                return _c("SectorPostCardLink", {
                  key: link.id,
                  attrs: { resource: link },
                })
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sector-post__interactions" }, [
        _c(
          "div",
          { staticClass: "sector-post__actions" },
          [
            _c("InteractionButton", {
              attrs: {
                title: "Like",
                icon: "filled-like",
                "icon-filled": true,
                isComplete: _vm.resource.is_liked,
                disabled: _vm.$wait.is("liking-post"),
              },
              on: { click: _vm.handleLikeClick },
            }),
            _vm._v(" "),
            _c("InteractionButton", {
              attrs: {
                title: "Comments",
                icon: "filled-comment",
                "icon-filled": true,
                count:
                  _vm.resource.comments_count > 0
                    ? _vm.resource.comments_count
                    : null,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("comment-click")
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sector-post__count" },
          [
            _c("LikesOverview", {
              attrs: {
                "sector-post": _vm.resource.id,
                likes: _vm.resource.likes,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.loadComments
        ? _c(
            "div",
            { staticClass: "sector-post__comments" },
            [
              _c("SectorPostCardComments", {
                ref: "commentsSection",
                attrs: { id: _vm.resource.id },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.id && _vm.loadComments
        ? _c("SectorPostCardCommentForm", {
            attrs: { "post-id": _vm.resource.id },
            on: {
              "comment-added": function ($event) {
                return _vm.$refs.commentsSection.fetchResource()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.can && _vm.resource.can.edit && _vm.showActions
        ? _c("vue-simple-context-menu", {
            ref: "sectorPostContextMenu",
            attrs: {
              "element-id": `sector-post-${_vm.resource.id}-menu`,
              options: [
                {
                  name: "Edit",
                  value: "action_edit",
                  class: "sector-post-edit",
                },
                {
                  name: "Delete",
                  value: "action_delete",
                  class: "sector-post-delete",
                },
              ],
            },
            on: { "option-clicked": _vm.optionClicked },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }